<p-table
  data-test-id="services-table"
  [alwaysShowPaginator]="false"
  [columns]="columns"
  [metaKeySelection]="false"
  [paginator]="true"
  [rows]="5"
  [scrollable]="true"
  [value]="services"
  [(selection)]="selected"
  (onRowSelect)="onRowSelect()"
  (onRowUnselect)="onRowUnselect()">
  <ng-template let-columns pTemplate="header">
    <tr>
      @for (col of columns; track col.field) {
        <th
          [ngStyle]="{'min-width': col.width, 'display': col.display}"
          [pSortableColumn]="col.field">
          @switch (col.field) {
            @default {
              <span [innerText]='col.header'></span>
            }
          }
        </th>
      }
    </tr>
  </ng-template>
  <ng-template let-rowData pTemplate="body">
    <tr [pSelectableRow]="rowData">
      @for (col of columns; track col.field) {
        <td
          [ngStyle]="{ minWidth: col.width, width: col.width }"
          >
          @switch (col.field) {
            @case ('') {
              <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
            }
            @case ('createdDate') {
              {{ rowData.createdDate | utcToLocal: 'MM/dd/yyyy hh:mm:ss a' }}
            }
            @case ('requestReceivedDate') {
              {{ rowData.requestReceivedDate | utcToLocal: 'MM/dd/yyyy hh:mm:ss a' }}
            }
            @case ('decisionDate') {
              {{ rowData.decisionDate | utcToLocal: 'MM/dd/yyyy hh:mm:ss a' }}
            }
            @case ('urgencyChangeDate') {
              {{ rowData.urgencyChangeDate | utcToLocal: 'MM/dd/yyyy hh:mm:ss a' }}
            }
            @case ('extensionTakenDate') {
              {{ rowData.extensionTakenDate | utcToLocal: 'MM/dd/yyyy hh:mm:ss a' }}
            }
            @case ('effectiveStartDate') {
              {{ rowData.effectiveStartDate | utcDateWithoutTimeZone: 'MM/dd/yyyy' }}
            }
            @case ('effectiveEndDate') {
              {{ rowData.effectiveEndDate | utcDateWithoutTimeZone: 'MM/dd/yyyy' }}
            }
            @case ('urgency') {
              {{ rowData.urgency }}
            }
            @case ('serviceStatus') {
              {{ rowData.serviceStatus }}
            }
            @case ('serviceStatusReason') {
              <span
                class="truncate"
                tooltipPosition="bottom"
                tooltipStyleClass="tooltip-xl-size"
                [pTooltip]="rowData.serviceStatusReason"
                >
                {{ rowData.serviceStatusReason }}
              </span>
            }
            @default {
              <div
                [innerText]='rowData[col.field]'
              ></div>
            }
          }
        </td>
      }
    </tr>
  </ng-template>
</p-table>
